module.exports = __webpack_public_path__ + "img/1142155102.a92ccdaf.jpg";